// placeholder parameters sumbitted with the GP Service that returns a report for the user-drawn feature set of parks and/or trails

export const evaluatorReport = {
  nameField: "TPL_P_NAME",
  projectsLayerId: "selectedProjects",
  serviceLayerId: "serviceAreas",
  tables: {
    Area: {
      chart: null,
      pdf: {
        y: 0,
      },
      head: {
        type: "Statistic",
        class: "Served",
        fields: [
          {
            disp: "Value",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_AREA",
            disp: "Service Area",
            fill_lt: "#89BDD9",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: 0,
            newpercentvalue: null,
            percentvalue: null,
          },
        ],
      },
    },
    Population: {
      chart: "bar",
      pdf: {
        y: 72,
      },
      head: {
        type: "Demographic",
        class: "Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_TOTPOPSVCA",
            disp: "Total Population",
            fill_lt: "#89BDD9",
            fill_dk: "#4797BF",
            stroke: "#007FAD",
            value: 0,
            newvalue: 0,
            newpercentvalue: null,
            percentvalue: null,
          },
        ],
      },
    },
    Age: {
      chart: "bar",
      pdf: {
        y: 216,
      },
      head: {
        type: "Demographic",
        class: "People Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            cname: "SUM_KIDS_SVCA",
            ctotname: "SUM_KIDS",
            name: "SUM_KIDSVCA",
            percent: "SUM_KIDSVCA_PCT",
            disp: "Youth (<20)",
            fill_lt: "#72B0CF",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_YOUNG_PRO_SVCA",
            ctotname: "SUM_YOUNG_PRO",
            name: "SUM_YOUNGPROSVCA",
            percent: "SUM_YOUNGPROSVCA_PCT",
            disp: "Adults (20-64)",
            fill_lt: "#9DC9E0",
            fill_dk: "#5DA4C7",
            stroke: "#4797BF",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_SENIORS_SVCA",
            ctotname: "SUM_SENIORS",
            name: "SUM_SENIORSVCA",
            percent: "SUM_SENIORSVCA_PCT",
            disp: "Seniors (>64)",
            fill_lt: "#E3F4FC",
            fill_dk: "#9DC9E0",
            stroke: "#89BDD9",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
        ],
      },
    },
    Income: {
      chart: "bar",
      pdf: {
        y: 360,
      },
      head: {
        type: "Demographic",
        class: "Households Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            cname: "SUM_HHILOWSVCA",
            ctotname: "SUM_TPLHHILOW",
            name: "SUM_HHILOWSVCA",
            percent: "SUM_HHILOWSVCA_PCT",
            disp: "Low Income (<75% MAI)",
            fill_lt: "#72B0CF",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_HHIMEDSVCA",
            ctotname: "SUM_TPLHHIMED",
            name: "SUM_HHIMEDSVCA",
            percent: "SUM_HHIMEDSVCA_PCT",
            disp: "Medium Income (75%-125% MAI)",
            fill_lt: "#9DC9E0",
            fill_dk: "#5DA4C7",
            stroke: "#4797BF",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_HHIHGHSVCA",
            ctotname: "SUM_TPLHHIHGH",
            name: "SUM_HHIHGHSVCA",
            percent: "SUM_HHIHGHSVCA_PCT",
            disp: "High income (>125% MAI)",
            fill_lt: "#E3F4FC",
            fill_dk: "#9DC9E0",
            stroke: "#89BDD9",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
        ],
      },
    },
    Race: {
      chart: "bar",
      horizontal: true,
      pdf: {
        y: 504,
      },
      head: {
        type: "Demographic",
        class: "People Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            cname: "SUM_WHITE_SVC",
            ctotname: "SUM_WHITE",
            name: "SUM_WHITE_SVC",
            percent: "SUM_WHITE_SVC_PCT",
            disp: "White",
            fill_lt: "#e3f5f4",
            fill_dk: "#9edbd9",
            stroke: "#74cbc8",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_BLACK_SVC",
            ctotname: "SUM_BLACK",
            name: "SUM_BLACK_SVC",
            percent: "SUM_BLACK_SVC_PCT",
            disp: "Black",
            fill_lt: "#dce2f0",
            fill_dk: "#c2cce4",
            stroke: "#a8b6d9",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_ASIAN_SVC",
            ctotname: "SUM_ASIAN",
            name: "SUM_ASIAN_SVC",
            percent: "SUM_ASIAN_SVC_PCT",
            disp: "Asian",
            fill_lt: "#cce1e9",
            fill_dk: "#4d96b1",
            stroke: "#006990",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_AMERINDSVC",
            ctotname: "SUM_AMERIND",
            name: "SUM_AMERINDSVC",
            percent: "SUM_AMERINDSVC_PCT",
            disp: "Native American",
            fill_lt: "#c9daac",
            fill_dk: "#a0be6d",
            stroke: "#85ab44",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_PACIFICSVC",
            ctotname: "SUM_PACIFIC",
            name: "SUM_PACIFICSVC",
            percent: "SUM_PACIFICSVC_PCT",
            disp: "Pacific Islander",
            fill_lt: "#d699ae",
            fill_dk: "#b74d6d",
            stroke: "#572828ad3358",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_OTHRACESVC",
            ctotname: "SUM_OTHRACE",
            name: "SUM_OTHRACESVC",
            percent: "SUM_OTHRACESVC_PCT",
            disp: "Other Race",
            fill_lt: "#f4c5a5",
            fill_dk: "#eb9a61",
            stroke: "#e78540",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_RACE2UPSVC",
            ctotname: "SUM_RACE2UP",
            name: "SUM_RACE2UPSVC",
            percent: "SUM_RACE2UPSVC_PCT",
            disp: "Two or More Races",
            fill_lt: "#f0e0a0",
            fill_dk: "#f3c958",
            stroke: "#f1be35",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
          {
            cname: "SUM_HISP_SVC",
            ctotname: "SUM_HISP",
            name: "SUM_HISP_SVC",
            percent: "SUM_HISP_SVC_PCT",
            disp: "Hispanic",
            fill_lt: "#f0f0bb",
            fill_dk: "#e4e589",
            stroke: "#d9da56",
            value: 0,
            newvalue: 0,
            newpercentvalue: 0,
            percentvalue: 0,
          },
        ],
      },
    },
  },
  ReportType: "Evaluator",
  ReportArea: "ServiceAreas",
  ProjectName: "NEW - Project Area Report",
  IsExistingPark: false,
  CityOrUrbanID: "",
  PlaceStats: {},
  UrbanStats: {},
  NewPlaceStats: {},
};
